import React from 'react'
import { useTranslation } from 'react-i18next'
import Tag from '../Tag'
import TagRequired from '../Tag/TagRequired'
import styles from './styles.module.css'

const Parameter = ({ isrequired = false, title = '', type = '' }) => {
  const { t } = useTranslation()

  return (
    <>
      <span className={styles.container}>
        <span className={styles.title}>{title}</span>
        {!!type && <Tag>{type}</Tag>}
        {!!isrequired && <TagRequired>{t('general.required')}</TagRequired>}
      </span>
    </>
  )
}

export default Parameter
